// extracted by mini-css-extract-plugin
export var addToCartButton = "_sv-b";
export var arrowButtonContainer = "_sv-9";
export var arrowButtonIcon = "_sv-a";
export var carouselArrowButton = "_sv-6";
export var carouselElementContainer = "_sv-1";
export var left = "_sv-7";
export var productDisplayCarouselContainer = "_sv-0";
export var productTileContainer = "_sv-2";
export var productTileImage = "_sv-4";
export var productTileImageContainer = "_sv-3";
export var productTileTitle = "_sv-5";
export var right = "_sv-8";
export var sliderOverflow = "_sv-c";